import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { isModalUrl } from 'src/utils/ModalRoute';

type ScrollToTopProps = RouteComponentProps<{}>;

type TryScrollToTopProps = Pick<ScrollToTopProps, 'location'>;

export function tryScrollToTop(currentProps: TryScrollToTopProps, prevProps: TryScrollToTopProps) {
  const { location: currentLocation } = currentProps;
  const { location: previousLocation } = prevProps;

  const { pathname: currentPathname, hash: currentHash } = currentLocation;
  const { pathname: previousPathname, hash: previousHash } = previousLocation;

  if (
    currentLocation === previousLocation ||
    currentLocation.pathname === previousLocation.pathname ||
    isModalUrl(currentPathname) ||
    isModalUrl(previousPathname) ||
    (currentPathname === previousPathname && (!!currentHash || !!previousHash))
  ) return false;

  try {
    window.scrollTo({
      top: 0,
      // to fake a page load
      behavior: 'auto',
    });
  } catch (e) {
    window.scrollTo(0, 0);
  }

  return true;
}

class ScrollToTop extends React.PureComponent<ScrollToTopProps> {
  componentDidUpdate(prevProps: ScrollToTopProps) {
    tryScrollToTop(this.props, prevProps);
  }

  render() {
    return this.props.children;
  }
}

const WithRouter = withRouter(ScrollToTop);
export { WithRouter as ScrollToTop };
